import { connect, Dispatch } from 'react-redux';
import AbstractDriveItemListPage, { AbstractDriveItemListPageProps } from '../abstract';
import { StoreState } from '../../../reducers';
import { getOrFetchDriveItemMeta } from '../../DriveItemList/actions';
import UserAgentUtils from '../../../utils/userAgent';
import { FetchStatus, getDriveItemStatusFromMap } from '../../DriveItemList/reducer';
import { myDocumentsNavItems, NavigationItemData } from '../constants';
import Utils from '../../../utils';
import { Api } from '../../../typings/api';

interface FolderDriveItemListPageProps extends AbstractDriveItemListPageProps {
	dispatch: Dispatch<StoreState>;
	privateDirId: number | undefined;
	sharedDirId: number | undefined;
	locale: string;
}

export class FolderDriveItemListPage extends AbstractDriveItemListPage<FolderDriveItemListPageProps> {

	headerLabel = 'messages.folder';
	noItemsLabel = 'messages.no_assets';

	componentWillReceiveProps(nextProps: FolderDriveItemListPageProps) {
		const { params, privateDirId, sharedDirId} = this.props;
		if (
			params !== nextProps.params
			|| privateDirId !== nextProps.privateDirId
			|| sharedDirId !== nextProps.sharedDirId
		) {
			this.initializeView(nextProps);
		}
	}

	initializeView(props: FolderDriveItemListPageProps): void {
		const driveFolderId = this.getDriveFolderId(props);
		if (driveFolderId && !UserAgentUtils.isMobileApp) {
			const { dispatch } = props;
			dispatch(getOrFetchDriveItemMeta(driveFolderId));
		}

		this.setState({
			navigationItems: this.getNavigationItems(props)
		});
	}

	getDriveItemIds(): number[] {
		const { driveList: { driveItems: driveItemsStore }, sharedDirId } = this.props;
		const driveFolderId = this.getDriveFolderId();
		const isPrivateDir = this.isPrivateDir(this.props);
		if (driveFolderId) {
			const driveFolder = driveItemsStore[driveFolderId];

			if (driveFolder) {
				const { resources } = driveFolder;
				if (resources) {
					let additionalFolders = sharedDirId && isPrivateDir ? [sharedDirId] : [];
					return [
						...additionalFolders,
						...resources
							.map(resource => resource.id)
							.filter(this.filterOutMyDocumentsFromRoot)
					];
				}
			}
		}
		return [];
	}

	filterOutMyDocumentsFromRoot = (resourceId: number): boolean => {
		const { galleryId, privateDirId } = this.props;
		const driveFolderId = this.getDriveFolderId();
		const isMyDocumentsInRoot = driveFolderId === galleryId && resourceId === privateDirId;
		return !isMyDocumentsInRoot;
	}

	isFetching(driveItemIds: number[]): boolean {
		const driveFolderId = this.getDriveFolderId();

		if (driveFolderId && !UserAgentUtils.isMobileApp) {
			const { driveItemsFetchStatus } = this.props.driveList;
			const driveFolderFetchStatus = getDriveItemStatusFromMap(driveItemsFetchStatus, driveFolderId);
			const { contentBlocksStatus, metaFetchStatus } = driveFolderFetchStatus;

			if (metaFetchStatus !== FetchStatus.FETCHED && metaFetchStatus !== FetchStatus.ERROR) {
				return true;
			}

			const blocks = Object.keys(contentBlocksStatus);
			for (let i = 0; i < blocks.length; i++) {
				const block = blocks[i];
				const blockStatus: FetchStatus = contentBlocksStatus[block];

				if (blockStatus === FetchStatus.FETCHING) {
					return true;
				}
			}
		}
		return false;
	}

	getNavigationItems(props: FolderDriveItemListPageProps): NavigationItemData[] {
		const isPrivateDir = this.isPrivateDir(props);
		return isPrivateDir ? [
			this.getTutorialNavigationItem(props.locale),
			...myDocumentsNavItems,
		] : [];
	}

	getTutorialNavigationItem(locale: string): NavigationItemData {
		const tutorialsByLocale = {
			'en_UK': {
				url: 'https://fr.zone-secure.net/149574/1170924/',
				image: './.gallery/static/images/tutorial_uprez_cover_EN.jpg',
			},
			'es_ES': {
				url: 'https://fr.zone-secure.net/149562/.uprez-tutorial',
				image: './.gallery/static/images/tutorial_uprez_cover_ES.jpg',
			},
			'fr_FR': {
				url: 'https://fr.zone-secure.net/149574/1150789/',
				image: './.gallery/static/images/tutorial_uprez_cover_FR.jpg',
			},
			'de_DE': {
				url: 'https://fr.zone-secure.net/149574/1170924/',
				image: './.gallery/static/images/tutorial_uprez_cover_EN.jpg',
			},
		};
		return {
			label: 'tutorial_uprez',
			type: Api.DriveItemType.ExternalLink,
			...tutorialsByLocale[locale]
		};
	}

	isPrivateDir(props: FolderDriveItemListPageProps): boolean {
		return this.getDriveFolderId(props) === props.privateDirId;
	}
}

const mapStateToProps = ({
	driveList,
	galleryInfos,
	galleryInfos: {
		config: galleryConfig
	},
	i18n: {
		locale
	}
}: StoreState) => {
	const privateDirId = Utils.getPrivateDirId(driveList, galleryConfig);
	const sharedDirId = Utils.getSharedDirId(driveList, galleryInfos);

	return {
		privateDirId,
		sharedDirId,
		locale
	};
};

export default connect(mapStateToProps)(FolderDriveItemListPage);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DriveItemListPage/extends/Folder.tsx